import Vue from 'vue'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'
import router from './routes.js'

Vue.use(VueLazyload), {
  loading: "./assets/loading.gif"
}


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
